import { type FunctionComponent } from 'react'

import { LoadingSpinner } from '@matillion/component-library'
import classnames from 'classnames'

import classes from './CenteredSpinner.module.scss'

interface CenteredSpinnerProps {
  size?: 'normal' | 'compact'
}

export const CenteredSpinner: FunctionComponent<CenteredSpinnerProps> = ({
  size = 'normal'
}) => {
  return (
    <div
      className={classnames(
        classes.CenteredSpinner,
        classes['CenteredSpinner--' + size]
      )}
    >
      <LoadingSpinner data-testid="loading-spinner" />
    </div>
  )
}
